import { asSingleStyleConfig } from '../../../../utils/theme';
export default asSingleStyleConfig({
  baseStyle: {
    borderColor: 'grey.270'
  }
});